import axios from 'axios'

//axios.defaults.baseURL = 'http://localhost:5002/'
axios.defaults.baseURL = 'https://api.planovivasaude.com.br/'

export function setAuthorization(token) {
   axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
 }

 export function unsetAuthorization() {
   delete axios.defaults.headers.common['Authorization']
 }

export default axios
